
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns9adaf4255eb203dda1bc259e8a585fb4en from './en.yaml'
            i18n.addResourceBundle('en', '9adaf4255eb203dda1bc259e8a585fb4', flattenObject(ns9adaf4255eb203dda1bc259e8a585fb4en), true, true);
        
        export default '9adaf4255eb203dda1bc259e8a585fb4';
    